<script setup lang="ts">
let props = defineProps({
  text: {
    type: String,
    required: true
  },
  id: {
    type: String,
  }
});

let emits = defineEmits(['click']);

function handleClick() {
  emits('click');
}
</script>

<template>
  <button
    class="tw-cursor-pointer tw-text-center tw-font-bold tw-text-namaFontColor-input-dark tw-py-2 tw-rounded-md tw-text-2xl mobile:tw-text-lg tw-bg-primary-light dark:tw-bg-primary-dark"
    @click="handleClick" :id="id" v-text="props.text"/>
</template>

<style scoped>
</style>
